export default function Card({ name, value }) {
    return (
        <div className="w-full flex flex-col rounded border p-4">
            <div className="text-sm text-gray-500">{name}</div>
            <div className="text-2xl font-semibold text-mono">{value}</div>
        </div >
    )
}